<i18n>
{
  "en": {
      "title": "Temperature Trend",
      "subTitle": "Graph representing the trend of the daily averages of the temperatures detected by the selected sensors, in the specific time interval set."

  },
  "it": {
      "title": "Andamento delle Temperature",
      "subTitle": "Grafico rappresentante l’andamento delle medie giornaliere delle temperature rilevate dai sensori selezionati, nello specifico intervallo di tempo impostato."
  }
}
</i18n>

<template>
  <BalloonTemplate :arrowDirection="'right'" id="root" :visible="visible" @close="$emit('close')">
    <template v-slot:header>
      <h1>{{ $t("title") }}</h1>
    </template>
    <template v-slot:content>
      <p>{{ $t("subTitle") }}</p>
    </template>
  </BalloonTemplate>
</template>
<script>
import BalloonTemplate from "../../BallonTemplate.vue";

export default {
  name: "tempTrendBalloon",
  components: {
    BalloonTemplate,
  },
  props: {
    visible: Boolean,
  },
};
</script>
<style scoped>
#root {
  width: 360px;
}
</style>
